<div *ngIf="!pdv" class="my-5">
    <h5 class="tar-name-preload text-center">Cargando datos del PDV...</h5>
    <div class="d-flex justify-content-center">
        <img class="" src="./assets/img/spinner-home.svg" width="30" alt="">
    </div>
</div>
